export default "__VITE_ASSET__DuJ5L9mI__"